import dayjs from 'dayjs'
export default {
    configuration: false,
    searchList: {
        searchTxt: [],
    },
    lsrmSearch: {
        searchTxt: [
            {
                name: '单据编码',
                value: 'contractCode',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '法务合同编码',
                value: 'legalContractCode',
                type: 'input',
                unfold: false,
                span: 3,
            },
            {
                name: '合同名称',
                value: 'contractName',
                type: 'input',
                unfold: false,
                span: 3,
            },
            {
                name: '供应商',
                value: 'suppliersName',
                advanceLabel: '供应商弹出框',
                type: 'advance',
                advanceConfig: [
                    { prop: 'ALL', value: '全部' },
                    { prop: 'supplierCode', value: '供应商编码' },
                    { prop: 'supplierName', value: '供应商名称' },
                ],
                tableConfig: [
                    { prop: 'supplierCode', value: '供应商编码' },
                    { prop: 'supplierName', value: '供应商名称' },
                    { prop: 'supplierTypeName', value: '供应商类型' },
                ],
                cbParams: [
                    'supplierCode#suppliersCode',
                    'supplierName#suppliersName',
                    'supplierType#supplierType',
                    'propertyNature#property',
                ],
                advanceUrl: '/supplier/getSupplierByServiceType',
                notFetchOnShow: true,
                queryConditionRequired: true,
                unfold: true,
                searchRequired: true,
                span: 3,
                advancePrefix: 'api-srm-web',
                prefix: 'api-srm-web',
            },
            {
                name: '仓库人员编码',
                value: 'warehouseWorkerNo',
                type: 'input',
                unfold: false,
                span: 3,
            },
            {
                name: '身份证号',
                value: 'idCardNo',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '手机号码',
                value: 'workerPhone',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '仓库人员名称',
                value: 'workerName',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '分公司',
                value: 'companyName',
                type: 'advance',
                unfold: true,
                advanceConfig: [
                    { prop: 'ALL', value: '全部' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                    { prop: 'companyCode', value: '分公司编码' },
                ],
                tableConfig: [
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
                advanceUrl: '/esCompany/popCompany',
                cbParams: ['companyCode#companyCode', 'companyNameCn#companyName'],
                span: 3,
            },
            {
                name: '经营中心',
                value: 'businessName',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '创建渠道',
                value: 'dataSource',
                type: 'select',
                unfold: false,
                span: 3,
                options: [
                    { label: 'LSRM', value: 'LSRM' },
                    { label: 'LSP', value: 'LSP' },
                ],
            },
            {
                name: '服务平台',
                value: 'siteName',
                type: 'advance',
                unfold: false,
                searchRequired: true,
                advanceConfig: [
                    { prop: 'ALL', value: '全部' },
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                ],
                tableConfig: [
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                ],
                advanceUrl: '/searchPlatform',
                cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                span: 3,
                advanceCascade: `companyCode#companyCode`,
                multiple: false,
                multipleDelConfirm: true,
                max: 5,
                multipleTableColumn: { prop: 'escoCompanyNameCn', value: '服务平台名称' },
            },
            {
                name: '仓库人员类型',
                value: 'workerType',
                type: 'select',
                unfold: false,
                multiple: true,
                searchRequired: true,
                span: 3,
                optionNum: 'WAREHOUSE_WORKER_TYPE',
            },
            {
                name: '业务类型(合同)',
                value: 'businessType',
                type: 'select',
                unfold: false,
                multiple: false,
                searchRequired: true,
                span: 3,
                optionNum: 'WAREHOUSE_DELEGATE_BUSINESS_TYPE',
            },
            {
                name: '委派函类型',
                value: 'delegateType',
                type: 'select',
                unfold: true,
                searchRequired: true,
                span: 3,
                optionNum: 'WAREHOUSE_DELEGATE_TYPE',
            },
            {
                name: '供应商签署状态',
                value: 'supplierSignStatusList',
                type: 'select',
                multiple: true,
                unfold: false,
                searchRequired: true,
                span: 3,
                optionNum: 'WAREHOUSE_SIGN_STATUS',
            },
            {
                name: '仓库人员签署状态',
                value: 'warehouseWorkerSignStatusList',
                type: 'select',
                multiple: true,
                unfold: false,
                searchRequired: true,
                span: 3,
                optionNum: 'WAREHOUSE_SIGN_STATUS',
            },
            {
                name: '审批状态',
                value: 'auditStatusList',
                type: 'select',
                unfold: true,
                multiple: true,
                searchRequired: true,
                span: 3,
                // options:[]
                optionNum: 'WAREHOUSE_DELEGATE_AUDIT_STATUS',
            },
            {
                name: '发薪日期配置',
                value: 'salaryPaydayCodeList',
                type: 'select',
                unfold: true,
                multiple: true,
                searchRequired: true,
                span: 3,
                optionNum: 'SALARY_PAYDAY',
            },
            {
                name: '状态',
                value: 'delegateStatus',
                type: 'select',
                multiple: false,
                unfold: true,
                searchRequired: true,
                span: 3,
                optionNum: 'WAREHOUSE_DELEGATE_STATUS',
            },
            {
                name: '物理仓',
                value: 'physicalWarehouseName',
                type: 'advance',
                advanceLabel: '物理仓',
                advanceConfig: [
                    { prop: 'ALL', value: '全部' },
                    { prop: 'whName', value: '物理仓名称' },
                    { prop: 'whCode', value: '物理仓编码' },
                ],
                tableConfig: [
                    { prop: 'whCode', value: '物理仓编码' },
                    { prop: 'whName', value: '名称' },
                    { prop: 'whAddress', value: '地址' },
                    { prop: 'whSquare', value: '仓库面积' },
                ],
                advanceUrl: '/supplier/supplierPhysicsWarehouse/pageList',
                prefix: 'api-srm-web',
                method: 'post',
                cbParams: [
                    'whCode#physicalWarehouseCode',
                    'whName#physicalWarehouseName',
                    // 'whNameArray#physicalWarehouseNameArray',
                ],
                // advanceCascade: 'supplierCode',
                multiple: false,
                multipleTableColumn: { prop: 'whName', value: '物理仓名称' },
                // multipleDelConfirm: true,
                max: 1,
                span: 4,
                unfold: false,
                // advanceRequire: [{ prop: 'supplierCode', message: '请先选择供应商名称!' }]
            },
            {
                name: '逻辑仓',
                value: 'logicalWarehouseName',
                type: 'advance',
                advanceLabel: '逻辑仓',
                advanceConfig: [
                    // { prop: 'ALL', value: '全部' },
                    { prop: 'cdwhName', value: '逻辑仓名称' },
                    { prop: 'whCode', value: '逻辑仓编码' },
                ],
                tableConfig: [
                    { prop: 'whCode', value: '逻辑仓编码' },
                    { prop: 'cdwhName', value: '逻辑仓名称' },
                ],
                advanceUrl: '/public/api/searchCdWarehouse',
                prefix: '/api-srm',
                method: 'get',
                cbParams: ['cdwhName#logicalWarehouseName', 'whCode#logicalWarehouseCode'],
                // advanceCascade: 'supplierCode',
                multiple: false,
                multipleTableColumn: { prop: 'cdwhName', value: '逻辑仓名称' },
                // multipleDelConfirm: true,
                max: 1,
                span: 4,
                unfold: false,
                // advanceRequire: [{ prop: 'supplierCode', message: '请先选择供应商名称!' }]
            },
            {
                name: '创建人',
                value: 'createUserName',
                type: 'input',
                unfold: false,
                span: 3,
            },
            {
                name: '审批人',
                value: 'approvalName',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '时间范围',
                value: 'timeRange',
                type: 'time',
                startPlaceholder: '开始时间',
                endPlaceholder: '结束时间',
                unfold: true,
                clearable: true,
                
                pickerOptions: {
                    shortcuts: [
                        {
                        text: '最近一周',
                        onClick(picker) {
                            const start = dayjs().startOf('day').subtract(6, 'd').toDate();
                            const end = dayjs().endOf('day').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一个月',
                        onClick(picker) {
                            const start = dayjs().startOf('day').subtract(30, 'd').toDate();
                            const end = dayjs().endOf('day').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const start = dayjs().startOf('day').subtract(90, 'd').toDate();
                            const end = dayjs().endOf('day').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
                span: 6,
            },
            {
                "name": "客户",
                "value": "customerName",
                "type": "advance",
                "unfold": false,
                "advanceConfig": [
                    { "prop": "ebcuNameCn", "value": "客户名称" },
                    { "prop": "pmCode", "value": "客户编码" }
                ],
                "tableConfig": [
                    { "prop": "ebcuNameCn", "value": "客户名称" },
                    { "prop": "pmCode", "value": "客户编码" }
                ],
                "advanceUrl": "/ebCustomer/searchByEbCustomer",
                "cbParams": ["pmCode#customerCode", "ebcuNameCn#customerName"],
                "span": 3,
                "multiple": true,
                "multipleTableColumn": { prop: 'ebcuNameCn', value: '客户名称' },
                "multipleDelConfirm": true,
                "max": 15,
            },
            {
                'name': '业务场景',
                'value': 'businessSceneList',
                'type': 'select',
                'multiple': true,
                'optionNum': 'BUSINESS_SCENE',
                'options': [],
                'span': 3,
                'unfold': false,
            },
        ],
        unfoldState: false,
        advancedBtn: true,
        resetBtn: true,
    },
    lspSearch: {
        searchTxt: [
            {
                name: '法务合同编码',
                value: 'legalContractCode',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '单据编码',
                value: 'contractCode',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '仓库人员编码',
                value: 'warehouseWorkerNo',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '名称',
                value: 'workerName',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '手机号',
                value: 'workerPhone',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '身份证号',
                value: 'idCardNo',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '手机号码',
                value: 'workerPhone',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '仓库人员类型',
                value: 'workerType',
                type: 'select',
                unfold: true,
                searchRequired: true,
                multiple: true,
                span: 3,
                optionNum: 'WAREHOUSE_WORKER_TYPE',
            },
            {
                name: '委派函类型',
                value: 'delegateType',
                type: 'select',
                unfold: true,
                searchRequired: true,
                span: 3,
                optionNum: 'WAREHOUSE_DELEGATE_TYPE',
            },
            {
                name: '审批状态',
                value: 'auditStatusList',
                type: 'select',
                unfold: true,
                multiple: true,
                searchRequired: true,
                span: 3,
                optionNum: 'WAREHOUSE_DELEGATE_AUDIT_STATUS',
            },
            {
                name: '供应商签署状态',
                value: 'supplierSignStatusList',
                type: 'select',
                multiple: true,
                unfold: false,
                searchRequired: true,
                span: 3,
                optionNum: 'WAREHOUSE_SIGN_STATUS',
            },
            {
                name: '仓库人员签署状态',
                value: 'warehouseWorkerSignStatusList',
                type: 'select',
                multiple: true,
                unfold: false,
                searchRequired: true,
                span: 3,
                optionNum: 'WAREHOUSE_SIGN_STATUS',
            },
            {
                name: '状态',
                value: 'delegateStatus',
                type: 'select',
                unfold: true,
                searchRequired: true,
                span: 3,
                optionNum: 'WAREHOUSE_DELEGATE_STATUS',
            },
            {
                name: '时间范围',
                value: 'timeRange',
                type: 'time',
                startPlaceholder: '开始时间',
                endPlaceholder: '结束时间',
                unfold: true,
                clearable: true,
                span: 6,
            },
            {
                name: '创建渠道',
                value: 'dataSource',
                type: 'select',
                unfold: false,
                span: 3,
                options: [
                    { label: 'LSRM', value: 'LSRM' },
                    { label: 'LSP', value: 'LSP' },
                ],
            },
        ],
        unfoldState: false,
        advancedBtn: true,
        resetBtn: true,
    },

    table: { columns: [] },
    lsrmTable: {
        // "switchType": true,
        // "tableCut": false,
        // "clickState": false,
        selectBtn: true,
        height: 'calc(100vh - 211px)',
        columns: [
            {
                label: '单据编码',
                prop: 'contractCode',
                width: '150px',
            },
            {
                label: '仓库人员类型',
                prop: '_workerType',
                width: '100px',
            },
            {
                label: '主工作逻辑仓',
                prop: 'mainLogicalWarehouseName',
                width: '230px',
            },
            {
                label: '姓名',
                prop: 'workerName',
                width: '120px',
            },
            {
                label: '年龄',
                prop: 'age',
                width: '80px',
            },
            {
                label: '客户名称',
                prop: 'customerName',
                info: '安心签-员工管理-客户名称',
                width: '150px',
            },
            {
                label: '业务场景',
                prop: '_businessScene',
                // type: 'select',
                // options: [],
                info: '安心签-员工管理-业务场景名称',
                // optionNum: 'BUSINESS_SCENE',
                width: '130px',
            },
            {
                label: '创建渠道',
                prop: 'dataSource',
                width: '120px',
            },
            {
                label: '委派函类型',
                prop: '_delegateType',
                width: '130px',
            },
            {
                label: '状态',
                prop: '_delegateStatus',
                width: '120px',
            },
            {
                label: '启用时间',
                prop: 'enableTime',
                width: '150px',
            },
            {
                label: '供应商签署状态',
                prop: '_supplierSignStatus',
                width: '150px',
            },
            {
                label: '仓库人员签署状态',
                prop: '_warehouseWorkerSignStatus',
                width: '160px',
            },
            {
                label: '手机号码',
                prop: '_workerPhone',
                width: '120px',
                sensitive: true,
                sensitiveValue: true,
                ifHas: '/warehouseDelegationLetter-10',
            },
            {
                label: '身份证号',
                prop: '_idCardNo',
                width: '160px',
                sensitive: true,
                sensitiveValue: true,
                ifHas: '/warehouseDelegationLetter-10',
            },
            {
                label: '审批状态',
                prop: '_auditStatus',
                width: '120px',
            },
            {
                label: '合同名称',
                prop: 'contractName',
                width: '150px',
            },
            {
                label: '分公司',
                prop: 'companyName',
                width: '130px',
            },
            {
                label: '经营中心',
                prop: 'businessName',
                width: '130px',
            },
            {
                label: '服务平台',
                prop: 'siteName',
                width: '130px',
            },
            {
                label: '业务类型（合同）',
                prop: '_businessType',
                width: '150px',
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '100px',
            },
            {
                label: '供应商名称',
                prop: 'supplierName',
                width: '150px',
            },
            {
                label: '物理仓',
                prop: 'physicalWarehouseName',
                width: '150px',
            },
            {
                label: '逻辑仓',
                prop: 'logicalWarehouseName',
                width: '150px',
            },
            {
                label: '发薪日期配置',
                prop: '_salaryPaydayCode',
                width: '100px',
            },
            {
                label: '仓库人员编码',
                prop: 'warehouseWorkerNo',
                width: '150px',
            },
           
            {
                label: '身份证有效期',
                prop: 'effectEndDate',
                width: '100px',
            },
            {
                label: '是否黑名单',
                prop: '_blackFlag', 
                width: '120px',
                info: '',
            },
            {
                label: '创建人',
                prop: 'createUserName',
                width: '150px',
            },
            {
                label: '审批人',
                prop: 'approvalName',
                width: '150px',
            },
            {
                label: '法务合同编码',
                prop: 'legalContractCode',
                width: '150px',
            },
            {
                label: '停用时间',
                prop: 'disableTime',
                width: '150px',
            },
            {
                label: '创建时间',
                prop: '_createTime',
                width: '150px',
            },
            {
                label: '更新人',
                prop: 'updateUserName',
                width: '170px',
            },
            {
                label: '更新时间',
                prop: '_updateTime',
                width: '150px',
            },
        ],
        action: [
            {
                type: 'text',
                label: '修改',
                size: 'mini',
                event: 'edit',
            },
            {
                type: 'text',
                label: '审批详情',
                size: 'mini',
                event: 'approvalDetails',
            },
            {
                type: 'text',
                label: '签署详情',
                size: 'mini',
                event: 'signDetails',
            },
            {
                type: 'text',
                label: '操作记录',
                size: 'mini',
                event: 'operationRecord',
            },
        ],
        leftOperation: true,
        leftWidth: 280,
    },
    lspTable: {
        // "switchType": true,
        // "tableCut": false,
        // "clickState": false,
        selectBtn: true,
        height: 'calc(100vh - 211px)',
        columns: [
            {
                label: '仓库人员编码',
                prop: 'warehouseWorkerNo',
                width: '150px',
            },
            {
                label: '仓库人员类型',
                prop: '_workerType',
                width: '100px',
            },
            {
                label: '主工作逻辑仓',
                prop: 'mainLogicalWarehouseName',
                width: '230px',
            },
            {
                label: '姓名',
                prop: 'workerName',
                width: '120px',
            },
            {
                label: '年龄',
                prop: 'age',
                width: '80px',
            },
            {
                label: '创建渠道',
                prop: 'dataSource',
                width: '120px',
            },
            {
                label: '手机号码',
                prop: '_workerPhone',
                width: '120px',
                sensitive: true,
                sensitiveValue: true,
                ifHas: '/warehouseDelegationLetter-10',
            },
            {
                label: '供应商签署状态',
                prop: '_supplierSignStatus',
                width: '150px',
            },
            {
                label: '仓库人员签署状态',
                prop: '_warehouseWorkerSignStatus',
                width: '160px',
            },
            {
                label: '审批状态',
                prop: '_auditStatus',
                width: '120px',
            },
            {
                label: '单据编码',
                prop: 'contractCode',
                width: '150px',
            },
            {
                label: '法务合同编码',
                prop: 'legalContractCode',
                width: '150px',
            },
            {
                label: '分公司',
                prop: 'companyName',
                width: '130px',
            },
            {
                label: '服务平台',
                prop: 'siteName',
                width: '130px',
            },
            {
                label: '业务类型（合同）',
                prop: '_businessType',
                width: '150px',
            },
            {
                label: '身份证号',
                prop: '_idCardNo',
                width: '160px',
                sensitive: true,
                sensitiveValue: true,
                ifHas: '/warehouseDelegationLetter-10',
            },
            {
                label: '身份证有效期',
                prop: 'effectEndDate',
                width: '100px',
            },
            {
                label: '委派函类型',
                prop: '_delegateType',
                width: '130px',
            },
            {
                label: '状态',
                prop: '_delegateStatus',
                width: '120px',
            },
            {
                label: '停用原因',
                prop: '_discontinueReason',
                width: '120px',
            },
            {
                label: '停用时间',
                prop: 'disableTime',
                width: '150px',
            },
            {
                label: '发薪日期配置',
                prop: '_salaryPaydayCode',
                width: '100px',
            },
            {
                label: '创建人',
                prop: 'createUserName',
                width: '150px',
            },
            {
                label: '创建时间',
                prop: '_createTime',
                width: '150px',
            },
            {
                label: '更新人',
                prop: 'updateUserName',
                width: '170px',
            },
            {
                label: '更新时间',
                prop: '_updateTime',
                width: '150px',
            },
        ],
        action: [
            {
                type: 'text',
                label: '修改',
                size: 'mini',
                event: 'edit',
            },
            {
                type: 'text',
                label: '审批详情',
                size: 'mini',
                event: 'approvalDetails',
            },
            {
                type: 'text',
                label: '签署详情',
                size: 'mini',
                event: 'signDetails',
            },
            {
                type: 'text',
                label: '操作记录',
                size: 'mini',
                event: 'operationRecord',
            },
        ],
        leftOperation: true,
        leftWidth: 280,
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
    },
}
